export const USER_PLAYER = 'USER_PLAYER';
export const COMPUTER_PLAYER = 'COMPUTER_PLAYER';
